export const __class__ = '__class__';
export const _serialize__ = '_serialize__';
